import React, { type ReactNode, useContext, useEffect } from 'react';

import { useIntl } from 'react-intl-next';

import { fg } from '@atlaskit/platform-feature-flags';
import { useUCSuggestions } from '@atlassian/navigation-bff-data-provider';
import { ConditionalRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { MenuControlContext } from '../../../utils';

export function MenuWrapper({ children }: { children: ReactNode }) {
	const crossAppCreationEnabled = fg('navx_universal_create_cross_app_creation_enabled');
	const { product, suggestionConfig, subProduct } = useContext(MenuControlContext);

	const { locale } = useIntl();

	const { fetchUCSuggestions } = useUCSuggestions({
		cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
		orgId: suggestionConfig.enabled ? suggestionConfig.orgId : '',
		userId: suggestionConfig.enabled ? suggestionConfig.accountId : '',
		product,
		locale,
		subProduct: suggestionConfig.enabled ? subProduct : undefined,
	});

	useEffect(() => {
		if (crossAppCreationEnabled && suggestionConfig.enabled) {
			fetchUCSuggestions();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [crossAppCreationEnabled, suggestionConfig.enabled, locale]);

	return <ConditionalRelayEnvironmentProvider>{children}</ConditionalRelayEnvironmentProvider>;
}
